import { Injectable } from '@angular/core';
import { SelectedFilter } from '../state/filter-store.service';
import { defaultListingPageSize } from '@features/listings/services/listings-query-param.service';

@Injectable({
  providedIn: 'root',
})
export class FilterQueryBuilderService {
  build(
    selectedFilter: SelectedFilter,
    pageNumber: number = 1,
    amountPerPage: number = defaultListingPageSize,
  ): string {
    const params = new URLSearchParams();
    params.append('page', pageNumber.toString());

    if (selectedFilter.leasingType.value !== null) {
      if (selectedFilter.leasingType.value == '6') {
        params.append(
          'leasing_type',
          selectedFilter.leasingType.value.toString(),
        );
      } else {
        params.append(
          'funding_id',
          selectedFilter.leasingType.value.toString(),
        );
      }
    }

    if (selectedFilter.isPrivateCustomer !== null) {
      params.append('ownership', selectedFilter.isPrivateCustomer ? '0' : '1');
    }

    const filterBrands = selectedFilter.brands || [];

    if (filterBrands.length > 0) {
      const makeIds = filterBrands.map((brand) => brand.id).join(',');
      const modelIds = filterBrands
        .flatMap((brand) =>
          (brand.children || []).flatMap((child) =>
            child.children?.length
              ? child.children.map((submodel) => submodel.id)
              : child.id,
          ),
        )
        .join(',');

      if (makeIds) {
        params.append('make', makeIds);
      }

      if (modelIds) {
        params.append('model', modelIds);
      }
    }

    if (selectedFilter.minYear != null) {
      params.append('year_min', selectedFilter.minYear.toString());
    }

    if (selectedFilter.maxYear != null) {
      params.append('year_max', selectedFilter.maxYear.toString());
    }

    if (selectedFilter.minMileage != null) {
      params.append('mileage_min', selectedFilter.minMileage.toString());
    }

    if (selectedFilter.maxMileage != null) {
      params.append('mileage_max', selectedFilter.maxMileage.toString());
    }

    if (selectedFilter.price_monthly_min != null) {
      params.append(
        'price_monthly_min',
        selectedFilter.price_monthly_min.toString(),
      );
    }

    if (selectedFilter.price_monthly_max != null) {
      params.append(
        'price_monthly_max',
        selectedFilter.price_monthly_max.toString(),
      );
    }

    if (selectedFilter.power_in_hp_min != null) {
      params.append(
        'power_in_hp_min',
        selectedFilter.power_in_hp_min.toString(),
      );
    }

    if (selectedFilter.power_in_hp_max != null) {
      params.append(
        'power_in_hp_max',
        selectedFilter.power_in_hp_max.toString(),
      );
    }

    if (selectedFilter.gear_type != null) {
      params.append('gear_type', selectedFilter.gear_type.toString());
    }

    if (selectedFilter.bodywork.length) {
      params.append('bodywork', selectedFilter.bodywork.join(','));
    }

    if (selectedFilter.dealer_id != null) {
      params.append('dealer_id', selectedFilter.dealer_id.toString());
    }

    if (selectedFilter.period != null) {
      params.append('period', selectedFilter.period.toString());
    }

    if (selectedFilter.down_payment_min != null) {
      params.append(
        'down_payment_min',
        selectedFilter.down_payment_min.toString(),
      );
    }

    if (selectedFilter.down_payment_max != null) {
      params.append(
        'down_payment_max',
        selectedFilter.down_payment_max.toString(),
      );
    }

    if (selectedFilter.kilometers_min != null) {
      params.append('kilometers_min', selectedFilter.kilometers_min.toString());
    }

    if (selectedFilter.kilometers_max != null) {
      params.append('kilometers_max', selectedFilter.kilometers_max.toString());
    }

    if (selectedFilter.fuel_type.length > 0) {
      params.append('fuel_type', selectedFilter.fuel_type.join(','));
    }

    if (selectedFilter.equipment.length > 0) {
      params.append('equipment', selectedFilter.equipment.join(','));
    }

    if (selectedFilter.seats != null) {
      params.append('seats', selectedFilter.seats.toString());
    }

    if (selectedFilter.doors != null) {
      params.append('doors', selectedFilter.doors.toString());
    }

    params.append('page_size', amountPerPage.toString());

    return `?${params.toString()}`;
  }
}
